<template lang="pug" src="./order.pug"></template>
<style lang="scss" src="./order.scss" scoped></style>

<script>

import helpers from '@/utils/helpers';
import copyToClipboard from '@/utils/copy';
import infoOrder from '@/views/pages/ReceiveOrders/info-order';
import {mapGetters, mapState} from 'vuex';
import config from '../../../../../config.json';
import {VDivider} from "vuetify/lib/components";
import {DateTime} from 'luxon';
import {localizeField} from "@/helpers/locales";

export default {
  components: {
    'v-info-order': infoOrder,
    'v-divider': VDivider
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    defaultTaxiNumber: config.defaultTaxiNumber,
    lateTime: '00:00',
    timer: '00:00',
    cookingDeadlineTimer: '00:00:00',
    cookingDeadlineTimerId: null,
    hideOrderTimeout: null,
    pooling: null,
    poolingLateTime: null,
    isShowDetails: true,
    requestProcessing: false,
    pollingComfortOrder: null,
    timeCondition: null,
    productMenu: false
  }),
  computed: {
    ...mapGetters(['roleName']),
    ...mapState({
      orderHistories: (state) => state.orders.orderHistories,
      options(state) {
        if (!this.order.brand) return [];

        return state.data.brandOptions && state.data.brandOptions[this.order.brand.id].options;
      },
      brandDetails(state) {
        return state.orders.brandDetails && state.orders.brandDetails[this.order.brand && this.order.brand.id];
      }
    }),
    additionalInfoVisible() {
      return this.order.isDelivery && !['new'].includes(this.order.status);
    },
    isLate() {
      return this.cookingDeadlineTimerId && DateTime.fromISO(this.order.deliveryCookTime).toMillis() < DateTime.now().toMillis();
    },
    orderClasses() {
      return {
        'highlight': this.brandDetails && this.brandDetails.settings && this.brandDetails.settings.borderColor,
        'web-order': this.order.fromInternet && !this.order.isDelivery,
        'reduced-comfort': this.reducedComfortOrder,
        'delivery-order': this.order.isDelivery,
      };
    },
    middleSectionVisible() {
      return this.order.isDelivery && !['admin-delivery', 'manager-establishment', 'admin-establishment'].includes(this.roleName);
    },
    products() {
      return [...this.order.deliveryOrderDetails];
    },
    addresses() {
      return this.order.addresses
          .map('description')
          .join(' >>> ') || this.$vuetify.lang.t('$vuetify.pages.ReceiveOrders.noAddress');
    },
    totalProductPrice() {
      if (!this.order.isDelivery) {
        return 0;
      }

      return Math.round(this.order.deliveryOrderDetails.reduce((sum, i) => sum + (i.price * i.quantity), 0));
    },
    isShowHideIcon() {
      const statuses = ['accepted', 'arrived', 'landed', 'cancelled', 'completed'];
      // [
      //   "new",
      //   "canceledKitchen",
      //   "notAccepted",
      //   "accepted",
      //   "paid",
      //   "paymentWait",
      //   "cooking",
      //   "canceledClient",
      //   "canceledClientPayment",
      //   "readyForDelivery",
      //   "handedToCourier",
      //   "delivered"
      // ]

      //заведение может скрыть если статус=canceledClient, notAccepted, handedToCourier
      //оба могут скрыть если статус=canceledClientPayment, notAccepted, canceledKitchen
      if (this.order.isDelivery) {
        if (['manager-establishment', 'admin-establishment', 'admin-delivery'].includes(this.roleName) && ['canceledClient', 'notAccepted', 'handedToCourier', 'delivered'].includes(this.order.deliveryStatus)) {
          return true;
        }

        if (['canceledClientPayment', 'canceledClient', 'canceledKitchen', 'notAccepted', 'handedToCourier', 'delivered'].includes(this.order.deliveryStatus)) {
          return true;
        }

        return false;
      } else {
        return statuses.includes(this.order.status);
      }
    },
    isShowNoCars() {
      const statuses = ['arrived', 'cancelled', 'accepted'];
      return statuses.includes(this.order.status);
    },
    isCorporate: function () {
      const roles = ['corporate-admin', 'corporate-user'];
      return roles.includes(this.order.client && this.order.client.user && this.order.client.user.roleName);
    },
    isDeliveryTime() {
      return !this.order.isLate && this.order.deliveryTime && this.order.status === 'accepted';
    },
    isLateTime() {
      return this.order.isLate && this.order.status === 'accepted';
    },
    establishmentAddress() {
      return this.order.isDelivery ? [this.order.establishment.addresses[0].place.street, this.order.establishment.addresses[0].place.houseNumber, this.order.establishment.addresses[0].place.name, this.order.establishment.addresses[0].place.city].filter(i => !!i).join(', ') : '';
    },
    leftOverTime() {
      let diff;

      switch (this.order.deliveryStatus) {
        case 'readyForDelivery':
        case 'handedToCourier':
          // eslint-disable-next-line no-case-declarations
          diff = DateTime.fromISO(this.order.deliveryCookTime).diff(DateTime.fromISO(this.order.updatedAt), ['hours', 'minutes']).toObject();

          return `${String(diff.hours).padStart(2, '0')}:${String(Math.round(diff.minutes)).padStart(2, '0')}`;

        case 'delivered':
          // eslint-disable-next-line no-case-declarations
          diff = DateTime.fromISO(this.order.arrivalTime).diff(DateTime.fromISO(this.order.createdAt), ['hours', 'minutes']).toObject();

          return `${String(diff.hours).padStart(2, '0')}:${String(Math.round(diff.minutes)).padStart(2, '0')}`;
      }

      return '';
    },
    isShowSmsStatus() {
      const statuses = ['accepted', 'arrived', 'cancelled'];
      return statuses.includes(this.order.status) && this.order.driver;
    },
    canReturnToSearch() {
      return this.order.status === 'cancelled' && !this.order.preOrderTime && this.order.fromInternet;
    },
    reducedComfortOrder() {
      const options = this.order.orderOptions;
      const className = options && options.length && options[0].optionClass && options[0].optionClass.className;

      return this.order.status === 'searching' && className === 'Comfort' && this.timeCondition && !this.order.fromInternet;
    }
  },
  setup() {
      return {
          localizeField
      };
  },
  watch: {
    'order.deliveryStatus'() {
      if (['accepted', 'cooking', 'paid'].includes(this.order.deliveryStatus)) {
        this.initDeadlineTimer();
      } else if (this.cookingDeadlineTimerId) {
        clearInterval(this.cookingDeadlineTimerId);
        this.cookingDeadlineTimerId = null;
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.pooling);
    clearInterval(this.poolingLateTime);
    clearInterval(this.cookingDeadlineTimerId);
  },
  created: function () {
    this.poolingLateTime = setInterval(() => {
      this.lateTime = helpers.initControllTimer(this.order.arrivalTime);
    }, 1000);
    this.pooling = setInterval(() => {
      this.timer = helpers.initControllTimer(this.order.createdAt);

      const date = new Date(this.order.createdAt);
      this.timeCondition = (new Date() - new Date(date.setSeconds(date.getSeconds() + this.order.startSearchTime))) > 60000;
    }, 1000);

    if (['accepted', 'cooking', 'paid'].includes(this.order.deliveryStatus)) {
      this.initDeadlineTimer();
    }

    this.options.forEach((option) => {
      const checkedOption = this.order.orderOptions.find(it => it.id === option.id);
      if (checkedOption) {
        option.checked = true;
      }
    });
  },
  methods: {
    onEditOrder() {
      this.$store.dispatch('orders/makeActiveOrder', this.order.id)
          .then(res => {
            if (res) {
              this.$emit('onActiveOrder', this.order.id);
            }
          });
    },
    initDeadlineTimer() {
      this.cookingDeadlineTimerId = setInterval(() => {
        this.cookingDeadlineTimer = Object.values(DateTime.fromISO(this.order.deliveryCookTime).diff(DateTime.now(), ['hours', 'minutes', 'seconds']).toObject()).map(i => String(Math.abs(Math.floor(i))).padStart(2, '0')).join(':');
      }, 1000);
    },
    toggleDetails(event) {
      this.isShowDetails = !this.isShowDetails;
      event.stopPropagation();
    },
    async cancelOrder() {
      if (this.requestProcessing) return;

      this.requestProcessing = true;

      this.$store.dispatch('orders/cancelOrder', {
        id: this.order.id,
        cancelReason: 'no-more-cars'
      }).finally(() => {
        this.$nextTick(() => {
          setTimeout(() => this.requestProcessing = false, 500);
        });
      });
    },
    duplicateOrder() {
      if (this.requestProcessing) return;

      this.requestProcessing = true;

      this.$store.dispatch('orders/duplicateOrder', {
        id: this.order.id
      }).finally(() => {
        this.$nextTick(() => {
          setTimeout(() => this.requestProcessing = false, 500);
        });
      });
    },
    hideOrder(event) {
      event.stopPropagation();
      this.$store.dispatch('orders/hideOrder', this.order.id);
    },
    returnSearch() {
      if (this.requestProcessing) return;

      this.requestProcessing = true;

      this.$store.dispatch('orders/returnToSearch', this.order.id).finally(() => {
        setTimeout(() => {
          this.requestProcessing = false;
        }, 500);
      });
    },
    copyToClipboard
  }
};
</script>
